// import React from 'react'
// import bannerBg from '../assets/img/Banners/InquiryBanner.jpg';
// import PageBanner from '../Components/PageBanner';
// const Inquiry = () => {
//   return (
//     <>
//       <PageBanner title='Inquiry' bannerBg={bannerBg} currentPage='Inquiry  ' />
//       <div className="contact-us-wrapper section-padding">
//       <div className="container">
//         <div className="row eq-height">
//           <div className="col-lg-12 col-12">
//             <div className="contact-form">
//               <h2>Product Details  </h2>

//               <form
//                 action="mail.php"
//                 method="POST"
//                 className="row"
//                 id="contact-form"
//               >
//                 <div className="col-md-12 col-12">
//                   <div className="single-personal-info">
//                     {/* <input type="text" name="name" placeholder="Name" /> */}
//                     <select name="product" className="form-control" required>
//                         <option value="1">Please Select the Product *</option>
//                         <option value="Raw_Cotton"> Raw Cotton</option>
//                         <option value="Consumer_Edible_Oils">Consumer Edible Oils</option>
//                         <option value="Commercial_Oils">Commercial Oils</option>
//                         <option value="Oil_Cakes_Cattle_Feeds">Oil Cakes (Cattle Feeds)</option>
//                         <option value="Oil_Meals">Oil Meals (Solvent Extracted De-Oiled Cakes)</option>
//                         <option value="Oil_seeds">Oil seeds / Grains / Pulses</option>
//                         <option value="Cotton_Yarns">Cotton Yarns</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="col-md-12 col-12">
//                   <div className="single-personal-info">
//                     <textarea
//                       name="message"
//                       placeholder="Other Specifications"
//                       defaultValue={""}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Quantity" placeholder="Quantity Required" />
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="DueDate" placeholder="Quote Due Date" />
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Schedule" placeholder="Delivery Schedule" />
//                   </div>
//                 </div>

//                 <h2>Contact Information </h2>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="CompayName" placeholder="Compay Name"  required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="CompayPerson" placeholder="Compay Person" required />
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Designation" placeholder="Designation/Position"  required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                   <select name="product" className="form-control">
//                         <option value="2">Please Select Business Nature *</option>
//                         <option value="Manufacturing"> Manufacturing </option>
//                         <option value="Agent">Agent</option>
//                         <option value="Traders">Traders</option>
//                         <option value="Other"> Other</option>
                       
//                     </select>
//                   </div>
//                 </div>
//                 <div className="col-md-12 col-12">
//                   <div className="single-personal-info">
//                     <textarea
//                       name="message"
//                       placeholder="Other Specifications"
//                       defaultValue={""}
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="City" placeholder="City" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Pincode" placeholder="Pincode" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="State" placeholder="State" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Country" placeholder="Country" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="number" name="Phone" placeholder="Phone" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="text" name="Fax" placeholder="Fax" />
//                   </div>
//                 </div>
               
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="email" name="email" placeholder="E-mail" required/>
//                   </div>
//                 </div>
//                 <div className="col-md-6 col-12">
//                   <div className="single-personal-info">
//                     <input type="email" name="Website" placeholder="Website" />
//                   </div>
//                 </div>
//                 <div className="col-md-12 col-12">
//                   <div className="single-personal-info">
//                   <select name="product" className="form-control">
//                         <option value="3">How you find us?</option>
//                         <option value="InternetSearch"> Internet Search </option>
//                         <option value="TradeShow">Trade Show</option>
//                         <option value="Magazine">Magazine</option>
//                         <option value="BusinessDirectory"> Business Directory</option>
//                         <option value="Other2"> Other  </option>
                       
//                     </select>
//                   </div>
//                 </div>
//                 <div className="col-md-12 col-12">
//                   <input
//                     className="submit-btn"
//                     type="submit"
//                     defaultValue="Submit Now"
//                   />
//                 </div>
//               </form>
//               <span className="form-message" />
//             </div>
//           </div>
//           <div className="col-lg-12 col-12">
//             <div className="contact-us-sidebar mt-5 mt-lg-0">
//               <div className="contact-info">
//                 <h2>Compay Info</h2>
//                 <div className="single-info">
//                   <div className="icon">
//                     <i className="flaticon-email" />
//                   </div>
//                   <div className="text">
//                     <span>Email Us</span>
//                     <h5>
//                       <a
//                         href="mailto:info@shreegita.com
// "
//                       >
//                         info@shreegita.com
//                       </a>
//                     </h5>
//                   </div>
//                 </div>
//                 <div className="single-info">
//                   <div className="icon">
//                     <i className="flaticon-phone-call-1" />
//                   </div>
//                   <div className="text">
//                     <span>Call Us</span>
//                     <h5>
//                     <a
//                         href="telto:912822250345"
//                       >
//                         +91-2822–250345
//                       </a>
//                       <br/>
//                     <a
//                         href="telto:2822250246"
//                       >
//                         +91-2822–250246
//                       </a>
//                     </h5>
//                   </div>
//                 </div>
//                 <div className="single-info">
//                   <div className="icon">
//                     <i className="flaticon-pin" />
//                   </div>
//                   <div className="text">
//                     <span>Location</span>
//                     <h5>Panchasar Road, Morbi–363641, Guj. INDIA</h5>
//                   </div>
//                 </div>
//               </div>
              
//               {/* <div className="live-chat">
//                 <h2>Live Chat</h2>
//                 <p>You can contact us on chat and explain your problems</p>
//                 <Link to="/about">
//                   <i className="flaticon-chatting" /> Live Chat to Executive
//                 </Link>
                
//               </div> */}
//               <div className=" live-chat  pt-5">
//                         <div className="footer-social-icon  d-flex justify-content-around   ">
//                         <a href="https://www.facebook.com/shreegita/" target="_blank" rel="noopener noreferrer">
//                   <i className="fab fa-facebook-f"></i>
//                 </a>
//                 <a href="https://x.com/i/flow/login?redirect_after_login=%2FIndianRawCotton" target="_blank" rel="noopener noreferrer">
//                   <i className="fab fa-twitter"></i>
//                 </a>
//                 <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
//                   <i className="fab fa-instagram"></i>
//                 </a>
//                 <a href="https://www.pinterest.com/" target="_blank" rel="noopener noreferrer">
//                   <i className="fab fa-pinterest-p"></i>
//                 </a>
//                         </div>
//                     </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     </>
//   )
// }

// export default Inquiry


import React, { useState } from 'react';
import bannerBg from '../assets/img/Banners/InquiryBanner.jpg';
import PageBanner from '../Components/PageBanner';

const Inquiry = () => {
  const [formData, setFormData] = useState({});
  const [formMessage, setFormMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch("https://shreegita.com/inquiry.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      // Check if the response status is OK (2xx)
      if (!response.ok) {
        throw new Error("Server error occurred.");
      }
  
      // Attempt to parse the response as JSON
      const data = await response.json();
  
      if (data.success) {
        setFormMessage("Your inquiry has been submitted successfully.");
      } else {
        setFormMessage("Failed to submit your inquiry. Please try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setFormMessage("An error occurred. Please try again later.");
    }
  };
  
  return (
    <>
      <PageBanner title='Inquiry' bannerBg={bannerBg} currentPage='Inquiry' />
      <div className="contact-us-wrapper section-padding">
        <div className="container">
          <div className="row eq-height">
            <div className="col-lg-12 col-12">
              <div className="contact-form">
                <h2>Product Details</h2>
                <form onSubmit={handleSubmit} className="row" id="contact-form">
  {/* Product Selection */}
  <div className="col-md-12">
    <div className="single-personal-info">
      <select name="product" className="form-control" required onChange={handleChange}>
        <option value="">Please Select the Product *</option>
        <option value="Raw_Cotton">Raw Cotton</option>
        <option value="Consumer_Edible_Oils">Consumer Edible Oils</option>
        <option value="Commercial_Oils">Commercial Oils</option>
        <option value="Oil_Cakes_Cattle_Feeds">Oil Cakes (Cattle Feeds)</option>
        <option value="Oil_Meals">Oil Meals</option>
        <option value="Oil_seeds">Oil seeds / Grains / Pulses</option>
        <option value="Cotton_Yarns">Cotton Yarns</option>
      </select>
    </div>
  </div>

  {/* Specifications */}
  <div className="col-md-12">
    <div className="single-personal-info">
      <textarea name="specifications" placeholder="Other Specifications" onChange={handleChange} />
    </div>
  </div>

  {/* Quantity, Due Date, Schedule */}
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Quantity" placeholder="Quantity Required" onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="date" name="DueDate" placeholder="Quote Due Date" onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Schedule" placeholder="Delivery Schedule" onChange={handleChange} />
    </div>
  </div>

  {/* Contact Information */}
  <div className="col-12">
    <h2>Contact Information</h2>
  </div>

  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="CompanyName" placeholder="Company Name" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="CompanyPerson" placeholder="Company Person" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Designation" placeholder="Designation/Position" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <select name="businessNature" className="form-control" required onChange={handleChange}>
        <option value="">Please Select Business Nature *</option>
        <option value="Manufacturing">Manufacturing</option>
        <option value="Agent">Agent</option>
        <option value="Traders">Traders</option>
        <option value="Other">Other</option>
      </select>
    </div>
  </div>

  {/* Other Info */}
  <div className="col-md-12">
    <div className="single-personal-info">
      <textarea name="otherInfo" placeholder="Other Specifications" required onChange={handleChange} />
    </div>
  </div>

  {/* Address */}
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="City" placeholder="City" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Pincode" placeholder="Pincode" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="State" placeholder="State" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Country" placeholder="Country" required onChange={handleChange} />
    </div>
  </div>

  {/* Contact Details */}
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="tel" name="Phone" placeholder="Phone" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Fax" placeholder="Fax" onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="email" name="email" placeholder="E-mail" required onChange={handleChange} />
    </div>
  </div>
  <div className="col-md-6">
    <div className="single-personal-info">
      <input type="text" name="Website" placeholder="Website" onChange={handleChange} />
    </div>
  </div>

  {/* Source */}
  <div className="col-md-12">
    <div className="single-personal-info">
      <select name="source" className="form-control" required onChange={handleChange}>
        <option value="">How did you find us? *</option>
        <option value="InternetSearch">Internet Search</option>
        <option value="TradeShow">Trade Show</option>
        <option value="Magazine">Magazine</option>
        <option value="BusinessDirectory">Business Directory</option>
        <option value="Other2">Other</option>
      </select>
    </div>
  </div>

  {/* Submit */}
  <div className="col-md-12">
    <input className="submit-btn" type="submit" value="Submit Now" />
    <span className="form-message">{formMessage}</span>
  </div>
</form>

              </div>
            </div>

            {/* Contact info section below remains unchanged */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Inquiry;
